import { __assign, __awaiter, __extends, __generator } from "tslib";
import * as React from 'react';
import style from './EditContact.scss';
import { translate } from 'react-i18next';
import Notifications from './Notifications';
import { FieldValueType } from './Fields';
import { scrollToElement, getDisplayName } from './utils/misc.utils';
import { validateFields, convertContactToFields, convertFieldsToContact, generateNewFields, updateCustomFields, handleAddField, } from './utils/FieldList.utils';
import { Modal, Box, MessageBoxFunctionalLayout, Loader, } from 'wix-style-react';
import AddNewField from './AddNewField/AddNewField';
import FieldList from './FIeldList/FieldList';
import { customDataHook } from './CustomField/CustomField';
import { builtInFieldDataHook } from './BuiltInField/BuiltInField';
export var ResponseStatuses;
(function (ResponseStatuses) {
    ResponseStatuses["DUPLICATE_WARNING"] = "DUPLICATE_WARNING";
    ResponseStatuses["UNKNOWN_ERROR"] = "UNKNOWN_ERROR";
    ResponseStatuses["EMPTY_REQUIRED_FIELDS_ERROR"] = "EMPTY_REQUIRED_FIELDS_ERROR";
    ResponseStatuses["SUCCESS_CREATE_ANOTHER"] = "SUCCESS_CREATE_ANOTHER";
    ResponseStatuses["VALIDATION_ERROR"] = "VALIDATION_ERROR";
})(ResponseStatuses || (ResponseStatuses = {}));
export var ECLoadingType;
(function (ECLoadingType) {
    ECLoadingType["SAVE"] = "SAVE";
    ECLoadingType["SAVE_AND_CREATE_ANOTHER"] = "SAVE_AND_CREATE_ANOTHER";
})(ECLoadingType || (ECLoadingType = {}));
var EditContact = /** @class */ (function (_super) {
    __extends(EditContact, _super);
    function EditContact(props) {
        var _this = _super.call(this, props) || this;
        _this.validateFieldList = function () {
            var validationError = validateFields(_this.state.fields, _this.props.requiredFields);
            if (validationError) {
                _this.setState({
                    loadingType: null,
                    responseStatus: ResponseStatuses.VALIDATION_ERROR,
                    validationError: validationError.type,
                    errorField: validationError.field,
                    responseOptions: null,
                }, function () { return _this.scrollToErrorField(); });
            }
            return validationError;
        };
        _this.handleAddField = function (field) {
            var _a = handleAddField(field, _this.state.fields, _this.state.newFields), fields = _a.fields, newFields = _a.newFields, newField = _a.newField;
            _this.setState({
                fields: fields,
                newFields: newFields || _this.state.newFields,
            }, function () { return _this.scrollToField(newField); });
        };
        _this.renderNotifications = function () { return (React.createElement(Notifications, { responseOptions: _this.state.responseOptions, responseStatus: _this.state.responseStatus, log: _this.props.log, onClose: function () { return _this.setState({ responseStatus: null }); } })); };
        var fields = convertContactToFields(_this.props.contact, _this.props.customFields, _this.props.prefilledFields, _this.props.contactsEnableBirthdayField);
        _this.state = {
            fields: fields,
            newFields: generateNewFields(_this.props.contact, _this.props.contactsEnableBirthdayField),
            responseStatus: null,
            responseOptions: null,
            loadingType: null,
            validationError: null,
            errorField: null,
        };
        return _this;
    }
    EditContact.prototype.componentDidUpdate = function (prevProps) {
        var _this = this;
        var _a = this.props, customFields = _a.customFields, contact = _a.contact, isOpen = _a.isOpen;
        var editContactOpened = isOpen && !prevProps.isOpen;
        var contactUpdated = prevProps.contact !== contact;
        var resetContact = editContactOpened && !contactUpdated;
        if (contactUpdated || editContactOpened) {
            this.setState({
                fields: convertContactToFields(resetContact ? null : contact, customFields, this.props.prefilledFields, this.props.contactsEnableBirthdayField),
                newFields: generateNewFields(resetContact ? null : contact, this.props.contactsEnableBirthdayField),
            });
        }
        else if (prevProps.customFields !== customFields) {
            var _b = updateCustomFields(this.state.fields, customFields), fields = _b.fields, newFields_1 = _b.newFields;
            this.setState({
                fields: fields,
            }, function () { return newFields_1.length > 0 && _this.scrollToField(newFields_1[0]); });
        }
    };
    EditContact.prototype.handleSave = function (createAnother) {
        return __awaiter(this, void 0, void 0, function () {
            var fields, contact, error, _a, contactDto, newLabels, response;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        fields = this.state.fields;
                        contact = this.props.contact;
                        this.setState({
                            loadingType: createAnother
                                ? ECLoadingType.SAVE_AND_CREATE_ANOTHER
                                : ECLoadingType.SAVE,
                        });
                        error = this.validateFieldList();
                        if (error) {
                            return [2 /*return*/];
                        }
                        _a = convertFieldsToContact(contact, fields), contactDto = _a.contact, newLabels = _a.newLabels;
                        return [4 /*yield*/, this.props.onSave(contactDto, {
                                newLabels: newLabels,
                                createAnother: createAnother,
                            })];
                    case 1:
                        response = _b.sent();
                        this.handleSaveResponse(response);
                        return [2 /*return*/];
                }
            });
        });
    };
    EditContact.prototype.scrollToErrorField = function () {
        var elm = document.getElementsByClassName('ec-error-field');
        elm.length && scrollToElement(elm[0]);
    };
    EditContact.prototype.scrollToNotificationBar = function () {
        this.scrollByDataHook('notifications-bar');
    };
    EditContact.prototype.scrollToField = function (field) {
        var dataHook = field.type === FieldValueType.CUSTOM
            ? customDataHook(field)
            : builtInFieldDataHook(field);
        this.scrollByDataHook(dataHook);
    };
    EditContact.prototype.scrollByDataHook = function (dataHook) {
        var elm = document.querySelector("[data-hook=\"" + dataHook + "\"]");
        elm && scrollToElement(elm);
    };
    EditContact.prototype.handleSaveResponse = function (response) {
        var _this = this;
        var responseStatus = response.responseStatus, responseOptions = response.responseOptions;
        var resetFields = responseStatus === ResponseStatuses.SUCCESS_CREATE_ANOTHER;
        var newState = {
            loadingType: null,
            responseStatus: null,
            responseOptions: null,
            validationError: null,
            errorField: null,
        };
        if (responseStatus) {
            newState = __assign(__assign({}, newState), { responseStatus: responseStatus,
                responseOptions: responseOptions });
        }
        if (resetFields) {
            newState.fields = convertContactToFields(null, this.props.customFields, null, this.props.contactsEnableBirthdayField);
        }
        this.setState(newState, responseStatus && (function () { return _this.scrollToNotificationBar(); }));
    };
    EditContact.prototype.handleClose = function () {
        this.setState({
            responseStatus: null,
            responseOptions: null,
        });
        this.props.onClose();
    };
    EditContact.prototype.renderFields = function () {
        var _this = this;
        var _a = this.state, newFields = _a.newFields, fields = _a.fields;
        var _b = this.props, log = _b.log, labels = _b.labels, countries = _b.countries, assigneeComponent = _b.assigneeComponent, contact = _b.contact, onRenameCustomField = _b.onRenameCustomField, requiredFields = _b.requiredFields, onCheckForDuplicateEmail = _b.onCheckForDuplicateEmail;
        return (React.createElement("div", { "data-hook": "edit-contact-fields-container", className: style.fieldsContainer },
            this.state.loadingType && this.renderFullModalLoader(),
            React.createElement(FieldList, { newFields: newFields, fields: fields, contactId: contact && contact.id, updateFields: function (updatedFields, updatedNewFields) {
                    if (updatedNewFields === void 0) { updatedNewFields = _this.state.newFields; }
                    return _this.setState({
                        fields: updatedFields,
                        newFields: updatedNewFields,
                    });
                }, log: log, labels: labels, countries: countries, assigneeComponent: assigneeComponent, onRenameCustomField: onRenameCustomField, requiredFields: requiredFields, errorField: this.state.errorField, validationError: this.state.validationError, onCheckForDuplicateEmail: onCheckForDuplicateEmail })));
    };
    EditContact.prototype.getTitle = function () {
        var _a = this.props, contact = _a.contact, t = _a.t, loadingContact = _a.loadingContact;
        if (loadingContact) {
            return t('editContact.editTitle');
        }
        return getDisplayName(contact) || t('editContact.newContactTitle');
    };
    EditContact.prototype.renderFullModalLoader = function () {
        return (React.createElement("div", { "data-hook": "edit-contact-full-loader", className: style.bigLoader }));
    };
    EditContact.prototype.renderButtonLoader = function () {
        return (React.createElement(Box, null,
            React.createElement(Loader, { size: "tiny" })));
    };
    EditContact.prototype.renderContent = function () {
        return (React.createElement(React.Fragment, null,
            this.state.responseStatus && this.renderNotifications(),
            this.renderFields()));
    };
    EditContact.prototype.renderLoader = function () {
        return (React.createElement(Box, { height: "546px", verticalAlign: "middle", align: "center" },
            React.createElement(Loader, { dataHook: "loader-edit-contact", text: this.props.t('editContact.loading') })));
    };
    EditContact.prototype.render = function () {
        var _this = this;
        var _a = this.props, t = _a.t, isOpen = _a.isOpen, contact = _a.contact, loadingContact = _a.loadingContact, log = _a.log, onCreateCustomField = _a.onCreateCustomField, hideSaveAndCreateAnother = _a.hideSaveAndCreateAnother;
        return (React.createElement(Modal, { dataHook: "edit-contact-modal", isOpen: isOpen, maxHeight: "700px" },
            React.createElement(MessageBoxFunctionalLayout, { dataHook: "edit-contact-box", maxHeight: "636px", title: this.getTitle(), confirmText: t('editContact.save'), cancelText: hideSaveAndCreateAnother
                    ? ''
                    : t('editContact.saveAndCreateAnother'), width: "624px", onOk: function () { return _this.handleSave(); }, onCancel: function () { return _this.handleSave(true); }, onClose: function () { return _this.handleClose(); }, hideFooter: loadingContact, sideActions: React.createElement(AddNewField, { log: log, newFields: this.state.newFields, onCreateCustomField: onCreateCustomField, handleAddField: this.handleAddField }), cancelPrefixIcon: this.state.loadingType === ECLoadingType.SAVE_AND_CREATE_ANOTHER
                    ? this.renderButtonLoader()
                    : null, confirmPrefixIcon: this.state.loadingType === ECLoadingType.SAVE
                    ? this.renderButtonLoader()
                    : null }, loadingContact ? this.renderLoader() : this.renderContent())));
    };
    return EditContact;
}(React.PureComponent));
export default translate()(EditContact);
//# sourceMappingURL=EditContact.js.map